import React from 'react'
import omit from 'lodash/omit'
import { FieldRenderProps } from 'react-final-form'
import FormGroup from '../FormGroup'
import { getDescribedBy, parseMessage } from '../Forms/utils'
import Input from '../Input'

type InputFieldProps = FieldRenderProps<string, HTMLElement>

const InputField = ({
  className,
  help,
  input,
  label,
  maxlength,
  meta,
  optional,
  required,
  inputClassName,
  ...props
}: InputFieldProps) => {
  const error = parseMessage(meta.error || props.error)?.toString()
  const success = parseMessage(props.success)?.toString()
  const touched = meta.touched || props.touched
  const fieldId = props.id ?? input.name

  return (
    <FormGroup
      className={className}
      disabled={input.disabled}
      error={error}
      help={help}
      inputId={fieldId}
      label={label}
      maxlength={maxlength}
      name={input.name}
      optional={optional}
      required={required}
      success={success}
      touched={touched}
      value={input.value}
    >
      <Input
        aria-describedby={getDescribedBy(fieldId, maxlength)}
        error={error}
        required={required}
        success={success ?? false}
        touched={touched}
        maxLength={maxlength}
        className={inputClassName}
        {...omit(input, ['success', 'touched'])}
        {...omit(props, ['success', 'touched'])}
      />
    </FormGroup>
  )
}

export default InputField
